
<div class="navbar-area">
    <div class="mobile-nav">
        <a routerLink="/" class="logo">
            <img src="assets/img/main/logo-small.png" alt="logo">
        </a>
    </div>

    <div class="main-nav">
        <div class="container">
            <nav class="navbar navbar-expand-md navbar-light">
                <a class="navbar-brand" routerLink="/">
                    <img src="assets/img/main/logo-small.png" height="50" alt="logo">
                </a>

                <div class="collapse navbar-collapse mean-menu" id="navbarSupportedContent">
                    <ul class="navbar-nav m-auto">
                        <li class="nav-item"><a routerLink="/" class="nav-link dropdown-toggle" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Home</a></li>
                        <li class="nav-item">
                            <a routerLink="/reports" class="nav-link dropdown-toggle" routerLinkActive="active">Reports</a>
                            <ul class="dropdown-menu">
                                <li class="nav-item"><a routerLink="/reports/startup-services" class="nav-link" routerLinkActive="active">Startup Services</a></li>
                            </ul>
                        </li>

                    </ul>

                </div>
            </nav>
        </div>
    </div>
</div>
